import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-merchant-container',
  templateUrl: './merchant-container.component.html',
  styleUrls: ['./merchant-container.component.scss'],
})
export class MerchantContainerComponent implements OnInit {
  path?: string;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.events.subscribe((_) => {
      this.path = this.router.url.split('/').at(3);
    });
  }
}
